import comp from "./CourseList";
export default comp;
